import React from "react";
import { ChromePicker } from "react-color";
import "../styles/components/ColorPicker.scss";
import ClearText from "../images/ClearText.svg";
export default function ColorPicker(props) {
  const {
    handleColorChange,
    hideColorPicker,
    color,
    displayColorPicker,
    displayColorPickerBorder,
    displayColorPickerFontColor,
    displayColorPickerScrollColor,
    displaycolorpickerTextBg,
    collectColorOnChangeComplete,
    scrollThumbColorPicker,
  } = props;

  const showColorPicker =
    displayColorPickerFontColor || displaycolorpickerTextBg
      ? "displayTextcolor"
      : displayColorPicker ||
        displayColorPickerBorder ||
        scrollThumbColorPicker ||
        scrollThumbColorPicker
      ? "displayButtoncolor"
      : displayColorPickerScrollColor
      ? "displayScrollColor"
      : "displayColor";

  React.useEffect(() => {
    let Element =
      document.getElementsByClassName("saturation-white")[0]?.children[1]
        .children[0];
    let hueComp =
      document.getElementsByClassName("flexbox-fix")[0].children[1]?.children[0]
        .children[0].children[0].children[1].children[0];
    let alphaComp =
      document.getElementsByClassName("flexbox-fix")[0].children[1]
        ?.children[1];
    if (Element) {
      Element.addEventListener("mouseup", collectColorOnChangeComplete);
    }
    if (hueComp) {
      hueComp.addEventListener("mouseup", collectColorOnChangeComplete);
    }
    if (alphaComp) {
      alphaComp.addEventListener("mouseup", collectColorOnChangeComplete);
    }
    return () => {
      Element.removeEventListener("mouseup", collectColorOnChangeComplete);
      alphaComp.removeEventListener("mouseup", collectColorOnChangeComplete);
      hueComp.removeEventListener("mouseup", collectColorOnChangeComplete);
    };
  }, []);

  return (
    <>
      <div className={showColorPicker}>
        <div className="colorPicker">
          <h5 style={{ paddingTop: "-10%" }}>Fill Color</h5>
          <div className="closePicker">
            <img
              src={ClearText}
              alt="Close"
              className="clearTextIcon clearText"
              onMouseDown={(e) => {
                // Commit + close on mousedown so it wins over document capture
                // click-outside handlers (same apply behavior, avoids double-close).
                e.preventDefault();
                e.stopPropagation();
                hideColorPicker();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </div>
        </div>
        <ChromePicker
          className="customChrome-picker"
          color={color}
          onChange={handleColorChange}
        />
      </div>
    </>
  );
}
